const useShare = () => {
  async function share(text, options = {}) {
    const { title = '', showFallbackButtons = true, container = document.body } = options;

    // بررسی پشتیبانی از Web Share API
    if (navigator.share) {
      try {
        await navigator.clipboard.writeText(text);
        showMessage('متن در کلیپ‌بورد کپی شد');
        await navigator.share({
          title: title,
          text: text,
        });
        return true;
      } catch (error) {
        console.log('خطا در اشتراک‌گذاری:', error);
        // اگر کاربر کنسل کرد یا خطای دیگری رخ داد، به روش جایگزین ادامه می‌دهیم
      }
    }

    // روش جایگزین: کپی به کلیپ‌بورد
    try {
      await navigator.clipboard.writeText(text);
      showMessage('متن در کلیپ‌بورد کپی شد');

      // نمایش دکمه‌های جایگزین اگر تنظیمات اجازه دهد
      if (showFallbackButtons) {
        showShareButtons(text, container);
      }

      return true;
    } catch (error) {
      console.log('خطا در کپی متن:', error);

      // اگر کپی ناموفق بود، فقط دکمه‌های اشتراک را نمایش بده
      if (showFallbackButtons) {
        showShareButtons(text, container);
      }

      showMessage('لطفاً از دکمه‌های اشتراک‌گذاری استفاده کنید');
      return false;
    }
  }

  function showMessage(message, duration = 3000) {
    // حذف پیام قبلی اگر وجود داشته باشد
    const existingMessage = document.getElementById('share-message');
    if (existingMessage) {
      existingMessage.remove();
    }

    // ایجاد المان پیام
    const messageElement = document.createElement('div');
    messageElement.id = 'share-message';
    messageElement.textContent = message;
    messageElement.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    z-index: 9999;
    font-family: inherit;
  `;

    document.body.appendChild(messageElement);

    // حذف پیام بعد از مدت زمان مشخص
    setTimeout(() => {
      messageElement.style.opacity = '0';
      messageElement.style.transition = 'opacity 0.5s';
      setTimeout(() => messageElement.remove(), 500);
    }, duration);
  }

  function showShareButtons(text, container) {
    // حذف پنل قبلی اگر وجود داشته باشد
    const existingPanel = document.getElementById('share-panel');
    if (existingPanel) {
      existingPanel.remove();
    }

    // ایجاد پنل اشتراک‌گذاری
    const panel = document.createElement('div');
    panel.id = 'share-panel';
    panel.style.cssText = `
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    padding: 20px;
    border-top: 1px solid #ddd;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    z-index: 9998;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  `;

    // دکمه بستن
    const closeButton = document.createElement('button');
    closeButton.textContent = '×';
    closeButton.style.cssText = `
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
  `;
    closeButton.onclick = () => panel.remove();
    panel.appendChild(closeButton);

    // عنوان پنل
    const title = document.createElement('div');
    title.textContent = 'اشتراک‌گذاری از طریق:';
    title.style.cssText = `
    width: 100%;
    text-align: center;
    margin-bottom: 15px;
    font-weight: bold;
  `;
    panel.appendChild(title);

    // اضافه کردن دکمه‌های اشتراک‌گذاری
    const encodedText = encodeURIComponent(text);

    // دکمه تلگرام
    addShareButton(panel, 'تلگرام', `https://t.me/share/url?url=&text=${encodedText}`, '#0088cc');

    // دکمه ایمیل
    addShareButton(panel, 'ایمیل', `mailto:?body=${encodedText}&subject=نرخ طلا و سکه`, '#DB4437');

    // دکمه کپی مجدد
    const copyButton = createButton('کپی متن', '#333');
    copyButton.onclick = async () => {
      try {
        await navigator.clipboard.writeText(text);
        showMessage('متن با موفقیت کپی شد');
      } catch (error) {
        showMessage('خطا در کپی متن');
      }
    };
    panel.appendChild(copyButton);

    // افزودن پنل به صفحه
    container.appendChild(panel);

    // انیمیشن نمایش
    setTimeout(() => {
      panel.style.transition = 'transform 0.3s';
      panel.style.transform = 'translateY(0)';
    }, 50);
  }

  function createButton(text, color) {
    const button = document.createElement('button');
    button.textContent = text;
    button.style.cssText = `
    background-color: ${color};
    color: white;
    border: none;
    border-radius: 5px;
    padding: 12px 20px;
    cursor: pointer;
    font-family: inherit;
    font-size: 14px;
    font-weight: bold;
    min-width: 120px;
  `;
    return button;
  }

  function addShareButton(panel, text, url, color) {
    const button = createButton(text, color);
    button.onclick = () => {
      window.open(url, '_blank');
    };
    panel.appendChild(button);
  }

  return { share };
};

export default useShare;
